import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>Bienvenue dans l'application Elo Quiz by Giuliano</h1>
      <p>Testez vos connaissances en cybersécurité et d'autres domaines !</p>
      <Link to="/quiz">
        <button>Commencer le Quiz</button>
      </Link>
    </div>
  );
};

export default Home;
